import { useQuery } from '@tanstack/react-query';

import { gql, VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(`
  query GetNarrativeValuationOptions($companyId: ID!) {
    company(ref: $companyId) {
      id
      valuationOptions {
      title
      type
      summary
      valuation {
        id
        narrative {
          id
          title
          isPrimary
          author {
            displayName
          }
        }
      }
      valuationId
      fairValue
      intrinsicDiscount
    }
  }
}
`);

type Variables = VariablesOf<typeof QUERY>;

export const useNarrativeValuationOptions = ({ companyId }: Variables) => {
  return useQuery({
    queryKey: useNarrativeValuationOptions.getQueryKey({ companyId }),
    queryFn: useNarrativeValuationOptions.fetcher({ companyId }),
  });
};

useNarrativeValuationOptions.getQueryKey = ({ companyId }: Variables) =>
  ['NARRATIVE_VALUATION_OPTIONS', companyId] as const;
useNarrativeValuationOptions.fetcher =
  ({ companyId }: Variables) =>
  () =>
    gqlClient.request(QUERY, {
      companyId,
    });
